import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "nav" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "home", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "today", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Calendar ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "list_alt", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Recent ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "save", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  style: {"max-width":"400px","margin":"100px auto","background":"#0d66bd","padding":"18px","color":"white","font-size":"16px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Welcome, please log in to continue", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Email", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Password", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  style: {"width":"90%","color":"#e50f0f","background":"#fff","margin-top":"5px","padding":"5px"}
}
const _hoisted_22 = { style: {"margin-top":"20px"} }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "update", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_o_loading = _resolveComponent("o-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.islogged && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _hoisted_4
              ]),
              _: 1
            }),
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: `/cal/${_ctx.cd.getFullYear()}/${_ctx.cd.getMonth() + 1}/${_ctx.cd.getDate()}`
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_8,
            _createVNode(_component_router_link, { to: "/recent" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _hoisted_11,
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
            }, _hoisted_14)
          ]),
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.islogged)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                style: {"width":"90%","padding":"5px"},
                placeholder: "Email"
              }, null, 512), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                style: {"width":"90%","padding":"5px"},
                placeholder: "Password"
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]),
            (_ctx.failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Incorrect email or password, please contact tech support. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                style: {"background":"white","color":"black","border":"1px solid gray","padding":"6px 15px","font-size":"18px"},
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
              }, " Login ")
            ])
          ])
        ]))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_o_loading, {
              "full-page": true,
              active: _ctx.loading,
              "can-cancel": false
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["active"])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}